import { produce } from 'immer';
import { SET_OVERRIDE_CONFIG_FAILURE_UNEXPECTED_FAILURE } from 'app/store/__generated__/events';
import { GET_OVERRIDE_CONFIG, GET_PUBLIC_CONFIG, SET_OVERRIDE_CONFIG } from './types.js';

export const INITIAL_STATE = {
    config: null,
    isSetOverrideConfigLoading: false,
    connection: {
        config: null,
        dialogOpen: false
    },
    error: null
};

export const applicationConfigReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_OVERRIDE_CONFIG.SUCCEEDED:
            draft.connection.config = action.payload.properties;
            break;
        case GET_PUBLIC_CONFIG.SUCCEEDED:
            draft.config = action.payload.config;
            break;
        case GET_OVERRIDE_CONFIG.FAILED:
        case SET_OVERRIDE_CONFIG_FAILURE_UNEXPECTED_FAILURE:
            draft.error = action.payload;
            break;
        case SET_OVERRIDE_CONFIG.STARTED:
            draft.isSetOverrideConfigLoading = true;
            break;
        case SET_OVERRIDE_CONFIG.ENDED:
            draft.isSetOverrideConfigLoading = false;
            break;
        default:
    }
}, INITIAL_STATE);
